import { backendAxios } from "../Services/axios";
import { iBuyOrder } from "../models/iOrder";
import store from "../../redux/redux";
import { setPendingOrders } from "../../redux/slices/orderSlice";
import openBuyModal from "../../_Web/components/Checkout/Buy";

export default class OrderController {
  static async getPendingOrders(): Promise<iBuyOrder[]> {
    const response = await backendAxios.get("/nft/buy-intent");
    return response.data;
  }

  static async deletePendingOrder(payload: { orderId: string }): Promise<any> {
    const response = await backendAxios.delete("/nft/buy-intent", {
      data: payload,
    });
    return response.data;
  }

  static async createPaymentIntent(payload: {
    nftId: string;
    source?: string;
  }) {
    const response = await backendAxios.post("/nft/buy-intent", payload);
    return response.data;
  }

  static async initPendingOrders() {
    const orders = await this.getPendingOrders();
    store.dispatch(setPendingOrders([...orders]));

    if (orders.length) {
      orders.forEach((o) => {
        openBuyModal(o.nftId);
      });
    }
  }

  static async closeAllPendingOrders() {
    const orders = await this.getPendingOrders();
    orders.forEach((o) => {
      this.deletePendingOrder({ orderId: o._id });
    });
  }
}
